import { render } from "./AcceptTermsCheckbox.vue?vue&type=template&id=7614c1a9"
import script from "./AcceptTermsCheckbox.vue?vue&type=script&lang=js"
export * from "./AcceptTermsCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__